import React, { useContext, useState } from "react";
import { Context } from "../store/appContext";
import ImportBatches from "./ImportBatches";
import getApiBaseUrl from "../utils/api";

const API_URL = getApiBaseUrl();

const WarehouseExcelImport = () => {
  const { store, actions } = useContext(Context);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [summary, setSummary] = useState(null);
  const [batchesRefreshKey, setBatchesRefreshKey] = useState(0);

  const refreshBatches = () => {
    setBatchesRefreshKey((currentValue) => currentValue + 1);
  };

  const handleFileChange = (event) => {
    const file = event.target.files?.[0] || null;
    setSelectedFile(file);
    setSummary(null);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!selectedFile) {
      actions.showToast("Selecciona un archivo Excel .xlsx", "warning");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    setIsSubmitting(true);
    setSummary(null);

    try {
      const response = await fetch(`${API_URL}/api/imports/warehouse-excel`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${store.token}`,
        },
        body: formData,
      });

      const payload = await response.json();
      refreshBatches();

      if (response.status === 401) {
        await actions.handleApiError(response);
        return;
      }

      if (response.status === 409) {
        const duplicateOfBatchId = payload?.data?.duplicate_of_batch_id;
        const message = duplicateOfBatchId
          ? `Archivo duplicado: ya existe el lote #${duplicateOfBatchId} con el mismo contenido.`
          : payload?.error || "Archivo duplicado detectado";

        actions.showToast(message, "warning");
        return;
      }

      if (!response.ok || !payload?.success) {
        const message =
          payload?.error || payload?.msg || "Error al importar el archivo";
        actions.showToast(message, "error");
        return;
      }

      setSummary(payload.data);
      actions.showToast("Importación completada", "success");
    } catch (error) {
      console.error("Warehouse Excel import error:", error);
      actions.showToast("No se pudo completar la importación", "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="container mt-4">
      <div className="row justify-content-center">
        <div className="col-lg-9">
          <div className="card shadow-sm">
            <div className="card-body">
              <h4 className="mb-3 text-center">Importación Excel almacén</h4>
              <p className="text-muted text-center mb-4">
                Carga un archivo real de movimientos para guardarlo en staging.
              </p>

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">Archivo Excel</label>
                  <input
                    className="form-control"
                    type="file"
                    accept=".xlsx"
                    onChange={handleFileChange}
                  />
                </div>

                <div className="d-grid">
                  <button
                    className="btn btn-primary"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Importando..." : "Subir archivo"}
                  </button>
                </div>
              </form>

              {summary && (
                <div className="mt-4">
                  <h5 className="mb-3">Resumen</h5>
                  <div className="table-responsive">
                    <table className="table table-sm">
                      <tbody>
                        <tr>
                          <th>Archivo</th>
                          <td>{summary.filename}</td>
                        </tr>
                        <tr>
                          <th>Hash</th>
                          <td>
                            <code>{summary.file_hash}</code>
                          </td>
                        </tr>
                        <tr>
                          <th>Filas recibidas</th>
                          <td>{summary.rows_received}</td>
                        </tr>
                        <tr>
                          <th>Filas insertadas</th>
                          <td>{summary.rows_inserted}</td>
                        </tr>
                        <tr>
                          <th>Reposición</th>
                          <td>{summary.summary.purchase_reposition}</td>
                        </tr>
                        <tr>
                          <th>Recuento entrada</th>
                          <td>{summary.summary.inventory_count_in}</td>
                        </tr>
                        <tr>
                          <th>Recuento salida</th>
                          <td>{summary.summary.inventory_count_out}</td>
                        </tr>
                        <tr>
                          <th>Ignorados</th>
                          <td>{summary.summary.ignored}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>

          <ImportBatches refreshKey={batchesRefreshKey} />
        </div>
      </div>
    </div>
  );
};

export default WarehouseExcelImport;
